import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, ClipboardList, UserCheck, HeartHandshake } from 'lucide-react';
export function CareJourney() {
  const steps = [{
    title: 'Schedule Assessment',
    description: 'Contact us to arrange a free, no-obligation in-home assessment with our clinical experts.',
    icon: <Calendar className="w-8 h-8" data-id="element-93" />,
    color: 'text-primary',
    bgColor: 'bg-primary/10'
  }, {
    title: 'Personalized Care Plan',
    description: 'We develop a customized care strategy tailored to your specific medical and personal needs.',
    icon: <ClipboardList className="w-8 h-8" data-id="element-94" />,
    color: 'text-secondary',
    bgColor: 'bg-secondary/10'
  }, {
    title: 'Professional Match',
    description: 'We carefully select a licensed caregiver who best matches your personality and requirements.',
    icon: <UserCheck className="w-8 h-8" data-id="element-95" />,
    color: 'text-primary',
    bgColor: 'bg-primary/10'
  }, {
    title: 'Ongoing Support',
    description: 'Receive continuous compassionate care with regular clinical oversight and family updates.',
    icon: <HeartHandshake className="w-8 h-8" data-id="element-96" />,
    color: 'text-secondary',
    bgColor: 'bg-secondary/10'
  }];
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-97">
      {/* Decorative Sinusoidal Line */}
      <div className="absolute top-1/2 left-0 w-full h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent -translate-y-1/2 hidden lg:block" data-id="element-98" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-99">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-100">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-secondary font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-101">
            The Process
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl lg:text-5xl font-heading font-bold text-dark-text mb-6" data-id="element-102">
            How We Care
          </motion.h2>
          <p className="text-lg text-body-text" data-id="element-103">
            Our streamlined process ensures your family receives the highest
            standard of care from day one.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-104">
          {steps.map((step, index) => <motion.div key={step.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="relative group" data-id="element-105">
              {/* Step Number */}
              <div className="absolute -top-6 -left-4 text-8xl font-black text-gray-50 select-none group-hover:text-primary/5 transition-colors duration-500" data-id="element-106">
                0{index + 1}
              </div>

              <div className="relative z-10" data-id="element-107">
                <div className={`w-20 h-20 ${step.bgColor} ${step.color} rounded-3xl flex items-center justify-center mb-8 shadow-sm group-hover:scale-110 transition-transform duration-500`} data-id="element-108">
                  {step.icon}
                </div>
                <h3 className="text-xl font-heading font-bold text-dark-text mb-4 group-hover:text-primary transition-colors" data-id="element-109">
                  {step.title}
                </h3>
                <p className="text-body-text leading-relaxed" data-id="element-110">
                  {step.description}
                </p>
              </div>

              {/* Connector for desktop */}
              {index < steps.length - 1 && <div className="absolute top-10 left-full w-full h-px bg-gradient-to-r from-gray-200 to-transparent hidden lg:block" data-id="element-111" />}
            </motion.div>)}
        </div>
      </div>
    </section>;
}